import { NavLink } from 'react-router-dom';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import Autocomplete from '@mui/material/Autocomplete';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import Paper from '@mui/material/Paper';

import theme from '../../theme';
import { styled } from '@mui/material/styles';

// ------------------------ LeftNav ------------------------ 
export const DrawerDesk = styled(Drawer)(props => ({
  '& .MuiDrawer-paper': {
    borderRight: `1px solid ${theme.palette.grey.w200}`,
    boxSizing: 'border-box',
    padding: '12px 12px 0 12px',
    backgroundColor: theme.palette.primary.w0,
    overflow: 'hidden',
    transition: 'all .5s'
  }
}))

export const BoxNavItem = styled(Box)({
  overflow: 'hidden',
  '&::-webkit-scrollbar': {
    display: 'none'
  },
  scrollbarWidth: 'none',
  msOverflowStyle: 'none'
})

export const StackNavIcon = styled(Stack)({
  marginTop: 'auto',
  borderTop: `1px solid ${theme.palette.grey.w200}`,
  padding: '8px 6px'
})

export const BoxMobileNav = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: '100vh',
  padding: '60px 12px 8px 12px',
  boxSizing: 'border-box',
})

export const BoxUserProfile = styled(Box)({
  padding: '20px 0',
  // borderBottom: `1px solid ${theme.palette.grey.w200}`
})

// ------------------------ LeftNavItem ------------------------ 
export const ButtonAddChat = styled(Button)({
  width: '100%',
  justifyContent: 'flex-start',
})

export const BoxChatRecord = styled(Box)({
  marginTop: '12px',
  // borderTop: `1px solid ${theme.palette.grey.w200}`,
  padding: '8px 12px'
})

export const NavLinkStyle = styled(NavLink)(({ ismobile, draweropen }) => {
  const color = {
    mainColor: theme.palette.text.primary,
    visitedColor: theme.palette.text,
    hoverColor: theme.palette.text,
    origibackground: 'none',
    changebackground: 'none',
  }

  if (draweropen === 'false' && ismobile === 'false') {
    return {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '8px 12px',
      margin: '6px 0',

      '&:hover, &.active': {
        color: color.hoverColor,
        borderRadius: '50px',
        backgroundColor: color.changebackground,

        '& .MuiSvgIcon-root': {
          color: color.hoverColor,
        },

        '&:before': {
          color: color.mainColor,
        }
      },
      '&:visited': {
        color: color.visitedColor,
      },
      '&:actived': {
        color: theme.palette.grey.w100,
      },
    }
  }

  return {
    color: color.mainColor,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '8px 12px',
    margin: '6px 0',
    borderRadius: '10px',

    '&:hover, &.active': {
      color: color.hoverColor,
      backgroundColor: color.changebackground,

      '& .MuiSvgIcon-root': {
        color: color.hoverColor,
      },

      '&:before': {
        color: color.mainColor,
        backgroundColor: color.origibackground,
      }
    },
    '&:visited': {
      color: color.visitedColor,
    },
    '&:actived': {
      color: theme.palette.grey.w100,
    },
  }

})

export const TxtStyle = {
  wordBreak: 'keep-all',
  whiteSpace: 'nowrap',
  marginLeft: '14px'
}
